import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-generate-schedules',
  templateUrl: './generate-schedules.component.html',
  styleUrls: ['./generate-schedules.component.scss']
})
export class GenerateSchedulesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
